import _ from 'lodash';
import { eventInitOf, REGISTER_EVENT_NAME, REGISTER_EVENT_OPTIONS } from './common';
export class RegisterEvent extends CustomEvent {
    constructor(injectable, requestedDependencies, customEventOptions) {
        super(REGISTER_EVENT_NAME, Object.assign(Object.assign(Object.assign({}, REGISTER_EVENT_OPTIONS), customEventOptions), { detail: Object.assign(Object.assign({}, customEventOptions === null || customEventOptions === void 0 ? void 0 : customEventOptions.detail), { injectable }) }));
        this.requestedDependencies = requestedDependencies;
        this.version = RegisterEvent.version;
        this.inject = this.detail.injectable.inject.bind(this.detail.injectable);
        this.context = {
            collectedDependencies: {},
            componentTree: [],
        };
    }
    get collectedDependencies() {
        return Object.assign({}, this.context.collectedDependencies);
    }
    get componentTree() {
        return _.cloneDeep(this.context.componentTree);
    }
    get targetComponent() {
        return this.context.componentTree[0];
    }
    bindComponent(data) {
        this.context.componentTree.push(data);
    }
    provideDependency(name, dependency) {
        if (name in this.context.collectedDependencies) {
            return false;
        }
        this.context.collectedDependencies[name] = dependency;
        return true;
    }
    /**
     * @deprecated - use {@link provideDependency} instead.
     */
    putIfAbsent(name, dependency) {
        return this.provideDependency(name, dependency);
    }
    clone() {
        return RegisterEvent.clone(this);
    }
    static from(event) {
        if (RegisterEvent.hasSameVersion(event)) {
            return RegisterEvent.clone(event);
        }
        else {
            return this.uplevel(event);
        }
    }
    static hasSameVersion(event) {
        return 'version' in event && event.version === RegisterEvent.version;
    }
    static clone(event) {
        const clone = new RegisterEvent(event, event.requestedDependencies, eventInitOf(event));
        _.merge(clone.context, _.cloneDeep(_.pick(event, Object.keys(clone.context))), {
            collectedDependencies: Object.assign({}, event.collectedDependencies),
        });
        return clone;
    }
    static uplevel(event) {
        const uplevel = new RegisterEvent({
            inject({ dependencies }) {
                event.detail.injectable.inject(Object.assign({ activatedRoute: dependencies.activatedRoute.v1, analytics: dependencies.analytics.v1beta1, breadcrumb: dependencies.breadcrumb.v1beta1, commandQueue: dependencies.commandQueue.v1, dispatcher: dependencies.dispatcher.v1, featureFlags: dependencies.featureFlags.v1.features, translator: dependencies.translator.v1 }, dependencies.additionalDependencies.v1));
            },
        }, {
            activatedRoute: ['v1'],
            analytics: ['v1beta1'],
            breadcrumb: ['v1beta1'],
            commandQueue: ['v1'],
            dispatcher: ['v1'],
            featureFlags: ['v1'],
            translator: ['v1'],
            additionalDependencies: ['v1'],
        }, eventInitOf(event));
        _.merge(uplevel.context, {
            collectedDependencies: Object.fromEntries(event.dependencies.entries()),
        });
        return uplevel;
    }
}
RegisterEvent.version = 'v2';
//# sourceMappingURL=v2.js.map